<template>
  <div class="mask">
    <transition
      name="show-mask"
    >
      <div class="mask__main" v-show="visible" :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}">
        <div class="mask__dialog">
          <div class="header">
            <div class="header__title">
              <div class="icon"></div>
              <div class="text">导入PPT</div>
            </div>
          </div>
          <div class="pic"></div>
          <div class="loading">
            <div
              class="icon"
              v-show="converting"
            >
              <div class="loader" id="__spin">
                <div class="loader-inner">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="icon done" v-show="!converting">
              <div v-if="state === 'fail'" class="cross"></div>
              <div v-else class="checkmark"></div>
            </div>
            <div class="text" v-if="state === 'fail'">PPT转换失败</div>
            <div class="text" v-else>{{converting ? loadingText : doneText}}</div>
          </div>
          <div class="text" v-show="converting">
            您的PPT文件正在快速转换中，然后您可以通过编辑项目导出视频作品!
          </div>
          <div class="text" v-show="state !== 'fail' && !converting">
            祝贺您！您的PPT文件已经转换完成，稍后您可以通过编辑项目导出视频作品！
          </div>
          <div class="text" v-show="state === 'fail' && !converting">
            抱歉！您的PPT文件转换失败，你可以进入<a class="link" :href="`${location.origin}/manage`" target="_blank">项目中心</a>选中项目选择重新进行转换！
          </div>
          <div class="btn-wrapper" v-show="converting && pptConnected">
            <div class="btn" @click="cancelConvert()">
              取消转换
            </div>
          </div>
          <div class="btn-wrapper" v-show="state !== 'fail' && !converting">
            <a class="a-text" :href="`${location.origin}${location.pathname}#/${PPTDraftId}`" target="_blank">
              <div class="btn" @click="openNewDraft()">
                编辑项目
              </div>
            </a>
          </div>
          <div class="wiki-link">
            *注意：更多关于一键导入PPT转换功能的细节，请<a class="link" :href="$getWikiLink('https://wiki.laihua.com/basic/ppt/ppt.html')" target="_blank">查看这里</a>
          </div>

          <div class="close-btn" @click="close()">
            关闭
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    visible: Boolean,
  },
  data () {
    return {
      loadingText: 'PPT转换中...',
      doneText: 'PPT转换完成！',
      converting: true,
      state: '',
      location: window.location,
      pptConnected: false
    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL',
      'PPTDraftId',
    ]),
    dialogStyle () {
      let { PfixLeft, PfixTop, clientHeight, clientWidth } = this.TOOL;
      let obj = {
        top: (PfixTop + clientHeight / 2) + 'px',
        left: (PfixLeft + clientWidth / 2) + 'px',
        transform: 'translate(-50%, -50%)',
      }
      return obj
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.toggleConverting(true);
          this.state = '';
        }
      }
    }
  },
  created () {
    this.$bus.on('pptConvertDone', () => {
      this.setConvertDone();
    });
    this.$bus.on('pptConvertFail', () => {
      this.setConvertFail();
    });
    this.$bus.on('pptConnected', (flag) => {
      this.pptConnected = flag;
    });
  },
  methods: {
    close () {
      this.$store.commit('save_TopnavMsg', {
        isShowPptMask: false
      });
    },
    toggleConverting (flag) {
      this.converting = flag;
    },
    cancelConvert () {
      this.$bus.emit('pptCancelConvert');
    },
    setConvertFail () {
      this.$nextTick(() => {
        this.converting = false;
        this.state = 'fail';
      })
    },
    setConvertDone () {
      this.$nextTick(() => {
        this.converting = false;
        this.state = '';
      })
    },
    openNewDraft () {
      this.$bus.emit('pptNewDraft');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";
.mask {
  &__main {
    position: relative;
    display: flex;
    justify-content: center;
    background-color: #fff; //rgba(#000, 0.5);
  }
  &__dialog {
    position: absolute;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    width: 1200px;
    height: 855px;
    background-color: #ffffff;

    &>span {
      margin-left: 1.2em;
    }

    &>.text {
      font-weight: bold;
    }
    & a {
      text-decoration: none;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 156px;

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 188px;
    height: 45px;
    & > .icon {
      display: inline-block;
      width: 42px;
      height: 45px;
      background-size: 100% 100%;
      background-image: url(../../../static/img/ppt-1.png);
    }
    & > .text {
      padding-left: 1em;
      color: #5778fb;
      font-weight: bold;
      font-size: 16px;
      transition-duration: 0.3s;
    }
  }
}
.pic {
  width: 570px;
	height: 321px;
  background-color: #f8f8f8;
  background-size: cover;
  background-image: url(../../../static/img/ppt-hero.png);
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
  font-weight: bold;

  > .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 26px;
    background-color: #f0f1f5;
  }
  > .text {
    padding-left: 1em;
  }
}
.btn-wrapper {
  margin-top: 54px;
}
.btn {
  line-height: 40px;
  width: 120px;
	height: 40px;
	background-color: #5778fb;
	border-radius: 4px;
  color: #fff;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  top: 50px;
  right: 47px;
  line-height: 40px;
  width: 120px;
	height: 40px;
  background-color: #f0f1f5;
	border-radius: 4px;
  font-size: 14px;
  transition-duration: 0.3s;
  &:hover {
    background-color: #5778fb;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}

.loader {
  position: relative;
  margin: 0 auto;
  width: 30px;
  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

.loader-inner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.circular {
  height: 100%;
  width: 100%;
  transform-origin: center center;
  // animation: rotate 2s linear infinite;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
  stroke: #5778fb;
  stroke-width: 4px;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

// .checkmark{
//   display:inline-block;

//   &:after{
//     /*Add another block-level blank space*/
//     content: '';
//     display: block;

//     /*Make it a small rectangle so the border will create an L-shape*/
//     width: 13px;
//     height: 20px;

//     /*Add a white border on the bottom and left, creating that 'L' */
//     border: solid #5778fb;
//     border-width: 0 3px 3px 0;

//     /*Rotate the L 45 degrees to turn it into a checkmark*/
//     transform: translatey(-2px) rotate(45deg);
//   }
// }

.checkmark {
  width: 22px;
  height: 16px;
  background-size: 100% 100%;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjYyOEU2OERDQUQxODExRTlCNzcwQTI2RERGOUNEQkQ0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjYyOEU2OEREQUQxODExRTlCNzcwQTI2RERGOUNEQkQ0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjI4RTY4REFBRDE4MTFFOUI3NzBBMjZEREY5Q0RCRDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjI4RTY4REJBRDE4MTFFOUI3NzBBMjZEREY5Q0RCRDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6qHNd1AAABKUlEQVR42mIMr/jNQAlY0c4CpiMq/zgCqR4gbgeKrWFhoAIAGmoNpPZBuauB/AAmKhjqBKSOoAlvoNRgkEv3YhFvp8RgOyA+jEW8BRjGVcgGa5NgKCiiDgIxI5p4LdDQWhADZnA9EF8B4oVEen8fFvFmoKEtMA4oVfQBcSGUHwfEoPSXgsNQByDej0W8AWhoI7IAC5KhMJAMxP+AOA1LmGIztAZoaCu6ICgotID4M5p4KhDPQuJbQsMUW0S1YvMayMXXgdgQiM8AsQCa4W+g4bkbi15QJLXgighY5N0FYgsg/oAmX0mOocgGg8BNqOHvCaSKZkKGohsMM9wYiD/iUF8DxHXEJHRsOe8+EJthMbwBiFuJzUG4svQtqOG3oSkG5P1GUvI7QIABAORoRefRSLOHAAAAAElFTkSuQmCC');
}

.cross {
  width: 17px;
  height: 17px;
  background-size: 100% 100%;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU4Njg4MjJDQUQxODExRTlCMEU3QTQ5RUMyQUYxMDM5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU4Njg4MjJEQUQxODExRTlCMEU3QTQ5RUMyQUYxMDM5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTg2ODgyMkFBRDE4MTFFOUIwRTdBNDlFQzJBRjEwMzkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTg2ODgyMkJBRDE4MTFFOUIwRTdBNDlFQzJBRjEwMzkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz54UDaYAAABSklEQVR42oSUu0pDQRCGTzarkMLe5xDFyjJ1GklUohC0F04untiHmItJJTZKvBVaCBZC3kDyEvElrCTe/oFZGNbZcwY+2Ot/Zv+dPblKsogQ62AC7kE/yo4DcAIaj107tWhsghewCnrgBwxTBKrgGtDep532165B45kFXAxAnCJwwwIUK+CORC6VxeecrowaC+S98VsS6YC2InQGWsKDK0VgDE9iKzYsFC/Iow1QAsabG7iPWO8IZOrIW7ytZEniiev46mO6NvAZMPabM0jkoAmY+hoQmQmfUkXoGosBkTXt+q3X3+OqDUWBM/3lo//LZB88KBvflDEyv+6L1LiUc4rRW5oPXA6JO84RuABLikAsasJwPcno4u1ErmKXvcm+YmBPHkHEKYkcgo+MdyO9aIo+Vfmx4Zoogzmn3cj4lwx5zTslgLcz+RNgAJT+RoV3+jtTAAAAAElFTkSuQmCC');
}

.show-mask-enter-active, .show-mask-leave-active {
  transition-duration: 0.5s;
  transform-origin: 0 100%;
}
.show-mask-enter, .show-mask-leave-to {
  transform: scale(0.1);
}

a.link {
  border-bottom: 1.4px solid #5778fb;

  &:visited {
    color: #5778fb;
  }
}

.wiki-link {
  margin-top: 30px;
  font-size: 12px;
  color: #9b9b9b;
  & > .link {
    color: #9b9b9b;
    border-color: #9b9b9b;
    border-width: 1px;
    &:visited {
      color: #9b9b9b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scenes/pptMask.vue